export const RegistrationType = {
    Email: "Email",
    Mobile: "Mobile",
    OneClick: "Oneclick",
    ManualOrWhatsApp: "Manual/WhatsApp",
};